export const AUDIO_CONTROL_EVENT = "miles-systems:audio-control";
export const AUDIO_STATE_EVENT = "miles-systems:audio-state";

export const audioTracks = [
  {
    title: "Eminence Front",
    artist: "The Who",
    src: "/audio/EminenceFront_TheWho.mp3",
  },
  {
    title: "Who Are You",
    artist: "The Who",
    src: "/audio/Who%20Are%20You.mp3",
  },
  {
    title: "Slow Morning Breakfast at the Camping",
    artist: "Soft LoFi Jazz House Music Mix",
    src: "/audio/Camping.mp3",
  },
] as const;

export type AudioControlDetail =
  | { action: "toggle" }
  | { action: "previous" }
  | { action: "next" }
  | { action: "volume"; volume: number };

export type AudioPlayerState = {
  isPlaying: boolean;
  trackIndex: number;
  trackTitle: string;
  trackArtist: string;
  volume: number;
};

export const defaultAudioPlayerState: AudioPlayerState = {
  isPlaying: false,
  trackIndex: 0,
  trackTitle: audioTracks[0].title,
  trackArtist: audioTracks[0].artist,
  volume: 0.42,
};
